import { Operation } from "@/backend/models/operation";
import { Parameter } from "@/backend/models/parameter";
import { useCreateConsumerReference, useGetParametersToAssignToOutput, useGetRefAndParameterBySource } from "@/frontend/hooks/parameters";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { ParameterType } from "@/types/parameterTypes";
import { OperationParameterSelect } from "./OperationParameterSelect";

export function OutputParameterSelect(props: { operation: Operation, parameter: Parameter }) {
  const { operation, parameter } = props;
  const scenario = useTreeStore(state => state.containerLookup[operation.parentId]);
  const parameters = useGetParametersToAssignToOutput(operation, parameter.fieldType, parameter.inputType);
  const createConsumerReference = useCreateConsumerReference(parameter.id);
  const { currentReference, currentParameter } = useGetRefAndParameterBySource(parameter.id);

  if (!scenario) {
    return null;
  }

  return (
    <OperationParameterSelect
      scenario={scenario}
      currentReference={currentReference}
      currentParameter={currentParameter}
      parameters={parameters}
      parameterType={ParameterType.OUTPUT}
      createReference={createConsumerReference}
      fieldType={parameter.fieldType}
      inputType={parameter.inputType}
    />
  );
}
